/** Default calendar identity chip colour (aligned with `--info`) */
export const CALENDAR_DEFAULT_EVENT_COLOR = "#4a9ce8";
